export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-[800px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            联系我们
          </h2>
          <p className="text-foreground-500 text-sm md:text-base">
            投稿爆料、商务合作、意见反馈
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
          <div className="flex flex-col items-center text-center p-6 rounded-xl bg-background-100 border border-background-200/70">
            <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-primary-100 text-primary-600 mb-4">
              <i className="ri-mail-send-line text-xl"></i>
            </div>
            <h3 className="font-semibold text-foreground-900 text-sm mb-2">投稿爆料</h3>
            <p className="text-xs text-foreground-500 mb-3">
              如果你有一手猛料线索，欢迎匿名投稿。我们会对每一位投稿人的信息严格保密。
            </p>
            <span className="text-sm text-primary-600 font-medium whitespace-nowrap">
              tips@51chigua.news
            </span>
          </div>

          <div className="flex flex-col items-center text-center p-6 rounded-xl bg-background-100 border border-background-200/70">
            <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-accent-100 text-accent-700 mb-4">
              <i className="ri-briefcase-line text-xl"></i>
            </div>
            <h3 className="font-semibold text-foreground-900 text-sm mb-2">商务合作</h3>
            <p className="text-xs text-foreground-500 mb-3">
              广告投放、品牌联动、内容授权等商务洽谈请通过以下方式联系。
            </p>
            <span className="text-sm text-accent-700 font-medium whitespace-nowrap">
              biz@51chigua.news
            </span>
          </div>

          <div className="flex flex-col items-center text-center p-6 rounded-xl bg-background-100 border border-background-200/70">
            <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-secondary-100 text-secondary-700 mb-4">
              <i className="ri-feedback-line text-xl"></i>
            </div>
            <h3 className="font-semibold text-foreground-900 text-sm mb-2">意见反馈</h3>
            <p className="text-xs text-foreground-500 mb-3">
              对平台内容或功能有任何建议和意见，我们非常乐意听取你的声音。
            </p>
            <span className="text-sm text-secondary-700 font-medium whitespace-nowrap">
              feedback@51chigua.news
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}